import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { UserType } from '../../interfaces/userType.enum';

const SystemAdminRoute = () => {
    const { user } = useAuth();
    const location = useLocation();

    // Check if user exists and has valid roles
    if (!user || !user.roles) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    // Handle both single role and multiple roles cases
    const userRoles = Array.isArray(user.roles) ? user.roles : [user.roles];

    if (!userRoles.includes(UserType.SystemAdmin)) {
        // Redirect to a safe route that won't cause an infinite loop
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};

export default SystemAdminRoute;
